module.exports = __webpack_public_path__ + "img/configurazione-invio-mail-prjweb.ba7f6821.png";